import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import HtmlParser from "react-html-parser";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { GetNetsuiteItemsCancelToken } from "../../../services/CourseService";
import {
  DeleteProgramme,
  GetListofModuleCancelToken,
  ListModulesFiltersCancelToken,
} from "../../../services/ProgramService";
import { handleTableScroll } from "../../../utils/commonFunction";
import { RenderModuleStatus, RenderModuleType } from "../../../utils/CommonGroupingItem";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import PermissionsGate from "../../../utils/permissionGate";
import Str from "../../common/Str";
import Tablefilter from "../../common/Tablefilter";
import { TrimText } from "../../common/TrimText";

const Modules = () => {
  const statusArr = {
    "Draft" : `<span class="table red">DRAFT </span> `,
    "New" : `<span class="table skyblue">NEW</span>`,
    "Final" : ` <span class="table green">FINAL</span>`,
    "Approved" : `<span class="table yellowshade">APPROVED</span>`,
    "Inactive" : `<span class="table blue">INACTIVE</span>`,
  }
  const history = useHistory();

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [dummy, setDummy] = useState(false);
  const [duration, setDuration] = useState({ arr: [], checkObj: {} });
  const [moduleStatus, setModuleStatus] = useState({ arr: [], checkObj: {} });
  const [filterData, setFilterData] = useState({type : []});

  const [netsuiteList, setNetsuiteList] = useState([]);
  const [loadingNS, setLoadingNS] = useState(false);

  useEffect(() => {
    setLoadingNS(true);
    const cancelTokenSources = [];
    const getData = async () => {
      cancelTokenSources.forEach((source) => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken?.source();
      cancelTokenSources.push(source);
      try { 
            const data = await GetNetsuiteItemsCancelToken(
              'All',
              source.token
            );
            if (data.status === 200) {
              setNetsuiteList(
                data && data.data && data.data.data && data.data.data.items
                ? data.data.data.items
                : []
              );
            }
            setLoadingNS(false);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log('error :', error);
        }
        setLoadingNS(false);
      }
    };

    getData();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  useEffect(() => {
    handleTableScroll()
  }, [loading])

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })

  usePermissionGuardRedirect(['pmcmview']);



  useEffect(() => {
    const cancelTokenSources = [];

    const getListOfModule = async () => {
      setLoading(true)
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      // setCancelTokenSources([...cancelTokenSources, source]);
      cancelTokenSources.push(source);
  
      try {
        const res = await GetListofModuleCancelToken(source.token);
        setData(res.data);
        if (res.status == 200) {
          setLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoading(false);
        }
      }
    }

    getListOfModule()

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [dummy]);

  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();
  
    const fetchData = async () => {
      try {
        const res = await ListModulesFiltersCancelToken(dropdownSource.token);
        setFilterData({...res.data, type : res.data.ModuleTypeFilter})
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };
  
    fetchData();
  
    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, []);

  const portalSort = (a, b) => {
    return a.Portal.toLowerCase() > b.Portal.toLowerCase() ? 1 : -1;
  };
  const MarketingSort = (a, b) => {
    if(a.Marketing_Name !== null && b.Marketing_Name !== null) {
      return a.Marketing_Name.toLowerCase() > b.Marketing_Name.toLowerCase()
      ? 1
      : -1;
    }
  };
  const codeSort = (a, b) => {
    return a.Code.toLowerCase() > b.Code.toLowerCase() ? 1 : -1;
  };
  const columns = useMemo(() => [
    {
      name: "Portal Names",
      selector: "Portal",
      sortable: true,
      sortFunction: portalSort,
      cell: (row) => (
        <PermissionsGate
          scopes={["pmcmedit"]}
          RenderError={() => (
            <span className="feature-name">
              {" "}
              <span className="textLimit100">{row.Portal}</span>
            </span>
          )}
        >
          <Link
            to={`/program-management-center/modules/module/open/${row.Id}`}
            className="as-text-blue curser feature-name"
            title={row.Portal}
          >
            {row?.Portal.trim() ? <span className="textLimit100">{row?.Portal}</span> : "-"}
          </Link>
        </PermissionsGate>
      ),
    },
    {
      name: "Code",
      selector: "Code",
      sortable: true,
      sortFunction: codeSort,
      cell: (row) => (
        <div className="ticket-id">
          {row.Code ? (
            <span title={row.Code} className="overflow-ellipsis2">
              {TrimText(row.Code, 10)}
            </span>
          ) : (
            "-"
          )}
        </div>
      ),
    },

    {
      name: "Marketing Name",
      selector: "Marketing_Name",
      sortable: true,
      sortFunction: MarketingSort,
      cell: (row) =>
        row.Marketing_Name ? (
          <span title={row.Marketing_Name} className="overflow-ellipsis2">
            {row.Marketing_Name.trim() ? TrimText(row.Marketing_Name, 20) : "-"}
          </span>
        ) : (
          "-"
        ),
    },
    // {
    //   name: "Duration (Weeks)",
    //   selector: "Duration",
    //   sortable: true,
    //   cell: (row) =>
    //     row.Duration && row.Duration.toString() ? (
    //       <span>{row.Duration}</span>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      name: "Status",
      selector: "module_status",
      sortable: true,
      cell: (row) => <span>{HtmlParser(statusArr[row.module_status])}</span>,
    },
    {
      name: "Term",
      selector: "term",
      sortable: true,
      cell: (row) => <span>{row.term}</span>,
    },
    {
      name: "Year",
      selector: "year",
      sortable: true,
      sortFunction: (a, b) => {
        // First, compare by year
        if (a.year !== b.year) {
          return a.year - b.year;
        }
        
        // If years are the same, compare by term
        // Convert term strings to arrays of numbers for proper comparison
        const getTermValue = (term) => {
          return term.split(',').map(Number);
        };
        
        const termA = getTermValue(a.term);
        const termB = getTermValue(b.term);
        for (let i = 0; i < Math.max(termA.length, termB.length); i++) {
          if ((termA[i] || 0) !== (termB[i] || 0)) {
            return (termA[i] || 0) - (termB[i] || 0);
          }
        }
        
        return 0; // If all term parts are equal
      },
      cell: (row) => <span>{row.year}</span>,
    },
    {
      name: "Netsuite Product",
      selector: "netsuite_product",
      sortable: true,
      cell: (row) => (<><span className = "textLimit100">{loadingNS ? <i className="fa fa-cog fa-spin"></i> : netsuiteList && netsuiteList.filter((data) => data.id == row.netsuite_product)?.[0]?.displayname || "-"  }</span></>),
    },
    {
      name: "Pre-Requisites",
      selector: "pre_requisites",
      sortable: true,
      cell: (row) => {
        // Parse the prerequisites and filter matching data
        let tempPrereqArray = [];
        tempPrereqArray = row.pre_requisites ? JSON.parse(row.pre_requisites) : [];
    
        // Filter matching data
        const prerequisites = Array.isArray(tempPrereqArray) 
          ? data.filter((dataItem) => tempPrereqArray.includes(dataItem.Id)) 
          : [];
    
        // Render prerequisites with a <br> after every 3rd item
        return (
          <span>
            {prerequisites.length > 0 
              ? prerequisites.map((item, index) => (
                  <React.Fragment key={index}>
                    <span>{item.Marketing_Name}</span>
                    {/* Add a comma and space if it's not the last item */}
                    {index < prerequisites.length - 1 && ', '}
                    {/* Add a <br> after every 3rd item */}
                    {(index + 1) % 3 === 0 && index < prerequisites.length - 1 && <br />}
                  </React.Fragment>
                ))
              : "-"
            }
          </span>
        );
      },
    },
    {
      name: "#Programmes",
      selector: "Programmes",
      sortable: true,
      cell: (row) =>
        row.Programmes.toString() ? (
          <div title={row.Programmes}>{row.Programmes}</div>
        ) : (
          "-"
        ),
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              RenderError={() => (
                <button
                  className="btn btn-primary rounded-circle"
                  title="Open"
                  disabled
                >
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
              scopes={["pmcmedit"]}
            >
              <Link
                to={`/program-management-center/modules/module/open/${row.Id}`}
                className="btn btn-primary rounded-circle"
                title="Open"
              >
                <i className="fal fa-folder-open"></i>
              </Link>
            </PermissionsGate>
            <div className="dropdown btn-dropdown-item">
              <button
                title="More"
                className="btn btn-primary rounded-circle dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <PermissionsGate
                  scopes={["pmcmadd"]}
                  RenderError={() => (
                    <button
                      className="btn btn-primary rounded-circle"
                      title="Duplicate"
                      disabled
                    >
                      <i className="fal fa-copy"></i>
                    </button>
                  )}
                >
                  <button
                    className="btn btn-primary rounded-circle"
                    title="Duplicate"
                    onClick={() =>
                      history.push(
                        "/program-management-center/modules/module/duplicate/" +
                        row.Id
                      )
                    }
                  >
                    <i className="fal fa-copy"></i>
                  </button>
                </PermissionsGate>

                <PermissionsGate
                  scopes={["pmcmdelete"]}
                  RenderError={() => (
                    <button
                      className="btn btn-danger rounded-circle"
                      title="Delete"
                      disabled
                    >
                      <i className="fal fa-trash-alt"></i>
                    </button>
                  )}
                >
                  <button
                    className="btn btn-danger rounded-circle"
                    title="Delete"
                    onClick={() => handleDelete(row.Id)}
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ]);

  const handleDelete = (ID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteProgramme({ id: ID })
          .then((res) => {
            Swal.fire("Deleted!", "Your module has been deleted.", "success");
            setDummy(!dummy);
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const dataToRender = () => {
    let updatedData = [];
    let allData = data;
    if (search.length) {
      let temp = allData.filter((item) => {
        let includes =
          item.Portal &&
          item.Portal.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempCode = allData.filter((item) => {
        let includes =
          item.Code &&
          item.Code.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempMarketing_Name = allData.filter((item) => {
        let includes =
          item.Marketing_Name &&
          item.Marketing_Name.toString()
            .toLowerCase()
            .includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempDuration = allData.filter((item) => {
        let includes =
          item.Duration &&
          item.Duration.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let temptopics = allData.filter((item) => {
        let includes =
          item.topics &&
          item.topics.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempModule_Type = allData.filter((item) => {
        let includes =
          item.Module_Type &&
          item.Module_Type.toString()
            .toLowerCase()
            .includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempProgrammes = allData.filter((item) => {
        let includes =
          item.Programmes &&
          item.Programmes.toString()
            .toLowerCase()
            .includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempdata = [
        ...tempCode,
        ...tempMarketing_Name,
        ...tempDuration,
        ...temptopics,
        ...tempModule_Type,
        ...tempProgrammes,
        ...temp,
      ];
      let unique = [...new Set(tempdata)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }
    if (search.length) {
      return updatedData;
    }
    if (duration.arr.length) {
      let tempData = updatedData;
      let tempSearch = tempData.filter((item) => {
        const startsWith = duration.arr.find((weeks) => {
          if (weeks === "1-4") {
            if (Number(item.Duration) > 1 && Number(item.Duration) <= 4)
              return item;
          }
          if (weeks === "5-8") {
            if (Number(item.Duration) > 4 && Number(item.Duration) <= 8)
              return item;
          }
          if (weeks === "9-12") {
            if (Number(item.Duration) > 8 && Number(item.Duration) <= 12)
              return item;
          }
          if (weeks === "> 12") {
            if (Number(item.Duration) > 12) return item;
          }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempSearch;
    }
    if (moduleStatus.arr.length) {
      let tempStudyType = updatedData;
      let tempSearch = tempStudyType.filter((item) => {
        const startsWith = moduleStatus.arr.find(function (post, index) {
          if (
            post.toLowerCase() ==
            (item.module_status ? item.module_status.toLowerCase() : "")
          )
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempSearch;
    }
    if (search.length || duration.arr.length || moduleStatus.arr.length) {
      return updatedData;
    } else {
      return data;
    }
  };
  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const resetFilter = () => {
    setSearch("");
    setDuration({ arr: [], checkObj: {} });
    setModuleStatus({ arr: [], checkObj: {} });
  };

  const exportData = (fileType, fileName) => {
    let data = dataToRender();
    const header = [
      "Portal Name",
      "Code",
      "Marketing Name",
      "Duration (Weeks)",
      "Status",
      "Year",
      "Term",
      "Programmes",
    ];

    data = data?.map((row) => ({
      ...row,
      "Portal Name": row?.Portal ? row.Portal : "-",
      Code: row.Code ? row?.Code : "-",
      "Marketing Name": row?.Marketing_Name ? row?.Marketing_Name : "-",
      Duration: row?.Duration ? row.Duration : "-",
      Status: row.module_status ? row.module_status : "-",
      Type: row.Module_Type ? RenderModuleType(row.Module_Type).text : "-",
      Year: row.year ? row.year + "-" + row.number : "-",
      Term: row.term ? row.term : "-",
      Topics: row.topics ? row.topics : "-",
    }));

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.map((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data.map((row) => {
        return [
          row["Portal Name"],
          row["Code"],
          row["Marketing Name"],
          row.Duration,
          row.Topics,
          row["module_status"],
          row.year,
          row.term,
          row["Programmes"],
        ];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          // valign: "center",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={handleSearchFilter}
                        value={search}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner  filter-custom-new`}>
                    <Tablefilter
                      filterName="Duration"
                      optionArr={
                        [
                          { value: "1-4", label: "1-4" },
                          { value: "4-8", label: "4-8" },
                          { value: "8-12", label: "8-12" },
                          { value: "> 12", label: "> 12" }
                        ]
                      }
                      state={duration}
                      setState={setDuration}
                      stopOptionSorting={true}
                    />
                    <Tablefilter
                      filterName="Type"
                      optionArr={[
                        {
                          value: "Draft",
                          label: "Draft" 
                        },
                        {
                          value: "New",
                          label: "New"
                        },
                        {
                          value: "Final",
                          label: "Final"
                        },
                        {
                          value: "Approved",
                          label: "Approved"
                        },
                        {
                          value: "Inactive",
                          label: "Inactive"
                        },
                      ]}
                      state={moduleStatus}
                      setState={setModuleStatus}
                      stopOptionSorting={true}
                      renderLabelFunction={RenderModuleStatus}
                    />
                  </div>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={() => resetFilter()}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Modules");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Modules");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Modules");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className=" filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <PermissionsGate
                  RenderError={() => (
                    <button
                      className="btn btn-primary"
                      title="Create New"
                      disabled
                    >
                      <i className="fal fa-plus"></i>Create New
                    </button>
                  )}
                  scopes={["pmcmadd"]}
                >
                  <button
                    className="btn btn-primary"
                    title="Create New"
                    onClick={() =>
                      history.push(
                        "/program-management-center/modules/module/add"
                      )
                    }
                  >
                    <i className="fal fa-plus"></i>Create New
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <SkeletonTicketList />
        ) : (
          <DataTable
            keyField="Id"
            data={dataToRender()}
            defaultSortField="year"
            defaultSortAsc={true}
            columns={columns}
            pagination={true}
            noDataComponent={Str.noRecord}
            paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
          />
        )}
      </div>
    </div>
  );
};

export default Modules;
